<template>
    <div style="margin-top: 50px">
        <v-card>
            <v-card-title primary-title class="justify-center">
                <p ><span class="headline primary--text font-weight-black">{{ $t("whistleblowing.contract.title") }}</span></p>
            </v-card-title>
            <v-card-text>
                <p class="title font-weight-bold">
                    {{ $t("whistleblowing.contract.content.first") }}<br/>
                    {{ $t("whistleblowing.contract.content.second") }}<br/>
                    {{ $t("whistleblowing.contract.content.third") }}
                </p>
            </v-card-text>
            <v-divider class="sm-4"></v-divider>
            <v-card-text class="red--text">
                <p class="title font-weight-bold">{{ $t("whistleblowing.contract.subTitle") }} : </p>
                <ol class="body-1">
                    <li>{{ $t("whistleblowing.contract.items.first") }}</li>
                    <li>{{ $t("whistleblowing.contract.items.second") }}</li>
                    <li>{{ $t("whistleblowing.contract.items.third") }}</li>
                    <li>{{ $t("whistleblowing.contract.items.fourth") }}</li>
                    <li>
                        {{ $t("whistleblowing.contract.items.fifth") }}
                        <div class="mt-2">
                            <v-btn
                                text
                                color="primary"
                                class="pa-0 flow-chart-link"
                                @click.prevent="openFlowChart"
                            >
                                {{ $t("whistleblowing.contract.flowChartLink") }}
                                <v-icon right small>mdi-open-in-new</v-icon>
                            </v-btn>
                        </div>
                    </li>
                </ol>
            </v-card-text>
            <v-card-actions>
                <v-row justify="center" align="center">
                    <v-checkbox color="primary" v-model="enabled" hide-details :label="$t('whistleblowing.contract.checkboxLabel')"></v-checkbox>
                </v-row>
            </v-card-actions>
            <v-card-actions>
                <v-row justify="center" align="center">
                    <v-btn class="button" color="primary" rounded :disabled="!enabled" @click.prevent="agree()">{{ $t("whistleblowing.contract.buttonText") }}</v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
    export default {
        name: "whistleblowingContract",
        components: {},
        data() {
            return {
                enabled: false,
                flowChartPdf: `${process.env.BASE_URL}flowChart.pdf`,
            };
        },
        methods: {
            agree() {
                this.$emit("done");
            },
            openFlowChart() {
                window.open(this.flowChartPdf, "_blank", "noopener,noreferrer");
            },
        },
    };
</script>

<style scoped>
    .flow-chart-link {
        min-width: auto;
        height: auto;
        text-transform: none;
        letter-spacing: normal;
        text-decoration: underline;
    }
</style>
